<template>
  <div :style="{ height: height }" class="top">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>绑定微信</span>
      </div>
      <div class="text item">
        <span class="status">状态： {{wxBindCount?('已绑定 ' + wxBindCount + ' / ' + wxBindMax + ' 个'):'未绑定'}}</span>
        <el-button class="btn" type="primary" size="small" v-if="checkPermission(funcData, 'bind') && wxBindCount < wxBindMax" @click="onQrcodeBind" plain>添加绑定</el-button>
        <el-button class="btn" type="danger" size="small" v-if="checkPermission(funcData, 'unbind') && wxBindCount > 0" @click="onQrcodeUnbind" plain>解除绑定</el-button>
        <el-button class="btn" type="danger" size="small" v-if="checkPermission(funcData, 'unbind') && wxBindCount > 0" @click="onAllUnind" plain>解绑全部</el-button>
      </div>
    </el-card>

    <!-- 绑定 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogBind" width="550px" top="8vh">
      <div slot="title">
        <div style="color: red; margin-top: 5px;">打开微信打码完成绑定</div>
      </div>

      <div style="padding: 0 50px; text-align: center; line-height: 40px;">
        <div>使用微信扫码(5分钟内有效)</div>
        <img style="width: 180px; height: 180px;" :src="imgUrlBind"/>
        <div>绑定后用于接收报警消息通知</div>
      </div>
    </el-dialog>

    <!-- 解绑 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogUnbind" width="550px" top="8vh">
      <div slot="title">
        <div style="color: red; margin-top: 5px;">打开微信打码完成解绑</div>
      </div>

      <div style="padding: 0 50px; text-align: center; line-height: 40px;">
        <div>使用微信扫码(5分钟内有效)</div>
        <img style="width: 180px; height: 180px;" :src="imgUrlUnbind"/>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      height: window.innerHeight - 200 + 'px',
      dialogBind: false,
      dialogUnbind: false,
      wxBindCount: 0,
      wxBindMax: 5,
      imgUrlBind: '',
      imgUrlUnbind: '',
      timer: ''
    }
  },
  mounted () {
    // this.getMerchInfo()
    this.getWxBindFlag()
    this.timer = setInterval(this.getWxBindFlag, 2000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    getWxBindFlag () {
      axios({
        url: this.baseUrl + '/wx/manager/bindFlag',
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.wxBindCount = res.data.data.count
          this.wxBindMax = res.data.data.max
          if (this.wxBindCount == 0) {
            this.dialogUnbind = false
          } else if (this.wxBindCount >= this.wxBindMax) {
            this.dialogBind = false
          }
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    onQrcodeBind () {
      axios({
        url: this.baseUrl + '/wx/manager/qrcodeBind',
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.imgUrlBind = res.data.data
          this.dialogBind = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onQrcodeUnbind () {
      axios({
        url: this.baseUrl + '/wx/manager/qrcodeUnbind',
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.imgUrlUnbind = res.data.data
          this.dialogUnbind = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onAllUnind () {
      this.$confirm('确认要解除全部绑定？')
        .then(_ => {
          axios({
            url: this.baseUrl + '/wx/manager/unbindAll',
            method: 'get'
          }).then(res => {
            if (res.data.code === '0000') {
              let flag = res.data.data
              if (flag) {
                this.wxBindCount = 0
                this.$message.success('解绑成功')
              }
            }
          }).catch(err => {
            console.log(err, 'loginerr')
          })
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang="scss" scope>
div.top {
  margin: 20px;
}
span.status {
  margin-right: 100px;
}
.el-dialog__header {
  border-bottom: #cccccc solid 1px;
}
.el-image-viewer__close {
  top: 80px;
}
</style>
